import React, { Component, Fragment } from "react";
import { connect } from 'react-redux'
import { currentWidget, setCallKeyclick, setRegPage, setShowCustomPopup } from '../../action/action'
import { setGoHome, setShowRoomDoor, setLoginRequired } from '../../layout2.0/action/homeAction'
import { HashRouter, Link, Redirect } from 'react-router-dom';
import DoorKeyPopup from './doorKeyPopup';
import { setShowDoorKeyPopup } from '../../layout2.0/action/action';
import $ from 'jquery'
import MobileKeyOverlay from './mobileKeyOverlay';
import {
    setDoorKeyNotificaionPage, popupOpenClose,
    setDeviceLoginPage, setDoorKeyValidationPopUp,
    SetCallNativeMethods
} from '../../action/action'
import {
    gettingKeyFailMsg, gettingKeySuccMsg, tapToUnlockMsg,
    gettingKeyMsg, successfulUnlock, tapToUnlockMsgTenSec,
    gettingKeySuccMsgTenSec, CMSPath,
    DEMO
} from '../../config/constant'
import {withTranslation} from "react-i18next";
import { clearDoorKey } from "../../JS/wipeGuestData";

// window.callFromNative = (key) => {
//     try {
//         console.log("callFromNative being called");
//         window.compRef.displayMessage(key);
//     } catch (e) {
//         console.log("error while tring to call js function from Native:", e);
//     }
// }

// window.runAfterPermissionsCheck = (key) => {
//     try {
//         // console.log("runAfterPermissionCheck being called");
//         window.compRef.runAfterPermissionsCheck(key);
//     }catch (e) {
//         console.log("error while tring to call runAfterPermissionCheck from Native:", e);
//     }
// };

class RoomDoor extends Component{

    constructor(props){
        super(props);
        this.state = {
            room: localStorage.getItem('room'),
            sliderLeft:0,
            doorUnlocked:false,
            doorKeyOpened: null,
            showOverlay:false,
            overlayComp: null,
            overlayMsg:null,
            tryAgainCase: null,
            showRoomDoorPage: false,
            showLocationErrScreen: false,
            singleUserReqRequest:false,
            showBlankOverlay:false
        }
        // window.compRef = this;
        this.timeOutClear = 0
    }

    requestLocationPermission = () => {
        const platform = window.device.platform;
        const self = this;

        if(platform == "Android") {
            window.cordova.plugins.diagnostic.requestRuntimePermissions(function(statuses){
                console.log('permission callback');
                for (var permission in statuses){
                    switch(statuses[permission]){
                        case window.cordova.plugins.diagnostic.permissionStatus.GRANTED:
                            console.log("Permission granted to use "+permission);
                            self.setState({showBlankOverlay:false})
                            self.runAfterPermissionGranted();
                            break;
                        case window.cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
                            console.log("NOT_REQUESTED")
                            console.log("Permission to use "+permission+" has not been requested yet");
                            self.setState({showBlankOverlay:false})
                            self.setState({showLocationErrScreen:true});
                            break;
                        case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ONCE:
                            console.log("DENIED_ONCE")
                            console.log("Permission denied to use "+permission+" - ask again?");
                            self.setState({showBlankOverlay:false})
                            self.setState({showLocationErrScreen:true});
                            break;
                        case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                            console.log("DENIED_ALWAYS")
                            console.log("Permission permanently denied to use "+permission+" - guess we won't be using it then!");
                            self.setState({showBlankOverlay:false})
                            self.setState({showLocationErrScreen:true});
                            break;
                        default:
                            console.log("request Runtime Permissions default statement.")
                            self.setState({showBlankOverlay:false})
                            self.setState({showLocationErrScreen:true});
                    }
                }
            }, function(error){
                console.error("The following error occurred: "+error);
                self.setState({showBlankOverlay:false})
                self.setState({showLocationErrScreen:true});
            },[
                window.cordova.plugins.diagnostic.permission.ACCESS_FINE_LOCATION,
                window.cordova.plugins.diagnostic.permission.ACCESS_COARSE_LOCATION
            ]);
        } else {
            self.setState({showBlankOverlay:false})
            self.runAfterPermissionGranted();
        }
    }


    nativeCalls = (SessionToken,reserNO,roomNo) => {
        console.log("nativeCalls");
        // let reserNO = localStorage.getItem("reservationNo");
        try {
            if (window.android.isEndpointSetupComplete()) {
                this.props.SetCallNativeMethods(false);
                console.log("isEndpointSetupComplete() success");
                if (window.android.getNumberOfMobileKeys() != 0) {
                    console.log("getNumberOfMobileKeys() success and openLock() called")
                    console.log("tapToUnlockMsg");
                    this.setState({showOverlay:false, overlayComp:"success"})
                    
                } else {
                    console.log("getNumberOfMobileKeys() failed and getMobileKey() called");
                    console.log("reservationNo", reserNO);
                    window.android.getMobileKey(CMSPath.slice(7), SessionToken, reserNO)
                    console.log("getNumberOfMobileKeys() failed gettingKeyMsg")
                    this.setState({showOverlay:true,overlayComp:"attention"})
                    // this.setState({ message: gettingKeyMsg });
                }
            } else {
                console.log("isEndpointSetupComplete() failed");
                console.log("reservationNo", reserNO);
                if (reserNO) {
                    if(!this.state.singleUserReqRequest){
                        window.android.userRegistration(CMSPath.slice(7), SessionToken, reserNO, roomNo);
                        console.log("isEndpointSetupComplete() failed gettingKeyMsg");
                        this.setState({singleUserReqRequest: true});  
                        this.setState({showOverlay:true,overlayComp:"attention"})
                    }
                    // this.setState({ message: gettingKeyMsg });
                }else{
                    this.setState({showOverlay:true,overlayComp:"error", overlayMsg: "isEndpointSetupComplete() failed",tryAgainCase: null});
                }
            }
        } catch (err) {
            console.log("error while checking digital key", err)
            this.setState({showOverlay:true,overlayComp:"error", overlayMsg: "error while checking digital key",tryAgainCase: null});
        }
    }

    activateFileHandler = () => {
        console.log("activateFile method called.")
        try{
            // window.android.activateFile();
            this.timeOutClear = window.setTimeout(() => {
                // this.setState({showOverlay:true,overlayComp:"error", overlayMsg: tapToUnlockMsgTenSec,tryAgainCase: "onKeySuccess"});
                this.setState({sliderLeft:0, doorUnlocked:false});
                // window.android.deActivateFile();
            }, 10000);
        }catch(e){
            console.log("Error while activating door key",e);
            this.setState({sliderLeft:0, doorUnlocked:false});
            this.setState({showOverlay:true,overlayComp:"error", overlayMsg: "Error while activating door key",tryAgainCase: null}); 
        }
    }

    setupSliderEventHandler = () => {

        const self = this;

        if($('#slider-unlock')[0]){
        $('#slider-unlock')[0].addEventListener('touchmove', function(event) {

            if(self.state.sliderLeft >= 230){
                return;
            }

            event.preventDefault();
            const el = event.target;
            const touch = event.touches[0];
            let curX = touch.pageX - this.offsetLeft - 60;
            if(curX <= 0) return;
            if(curX > 200){
                // $('well').style.opacity = 0;
                // alert("activated");
                self.setState({doorUnlocked:true})
                if(window.screen.width > 360){
                    self.setState({sliderLeft: 235})
                }else {
                    self.setState({sliderLeft: 220})
                }
                self.activateFileHandler();
                return;
            }
                self.setState({sliderLeft: curX})
            //    el.style.left = curX + 'px';
        }, false);
        
        $('#slider-unlock')[0].addEventListener('touchend', function(event) {

            if(self.state.sliderLeft >= 200){
                return;
            }

            this.style.webkitTransition = '-webkit-transform 0.3s ease-in';
            this.addEventListener( 'webkitTransitionEnd', function( event ) { this.style.webkitTransition = 'none'; }, false );
            self.setState({sliderLeft: 0})
        }, false);
    }}

    handleActivateDoorKeyFileHanlder = () => {
        this.setState({doorUnlocked:true})
        this.activateFileHandler();
    }

    displayMessage = (key) => {
        switch (key) {
            case 0:
                console.log("displayMessage case 0");
                this.setState({showOverlay:true,overlayComp:"error", overlayMsg: gettingKeyFailMsg,tryAgainCase: null});
                // this.setState({ message: gettingKeyFailMsg, tryAgain: true, tryAgainCase: "GetKeyFail" });
                break;
            case 1:
                console.log("displayMessage case 1");
                this.setState({showOverlay:false, overlayComp:"success"})
               
                /*this.setState({ message: gettingKeySuccMsg });
                this.timeOutClear = window.setTimeout(() => {
                    window.android.stopScan();
                    this.setState({ message: gettingKeySuccMsgTenSec, tryAgain: true, tryAgainCase: "onKeySuccess" });
                }, 10000);*/
                break;
            case 2:
                console.log("displayMessage case 2");
                this.setState({showOverlay:true,overlayComp:"success",overlayMsg:successfulUnlock})

                /*this.setState({
                    //  message: successfulUnlock,
                    tryAgain: false
                });
                window.clearTimeout(this.timeOutClear);
                window.android.stopScan();*/
                break;
            case 3:
                this.setState({showOverlay:true,overlayComp:"error", overlayMsg: this.props.t('door_key.door_unlock_failed'),tryAgainCase: null});
                break;
            default:
                console.log("no case match.");
        }
    }

    componentWillUnmount(){
        this.props.currentWidget({});

        if($("#slider-unlock")[0]){
            $("#slider-unlock")[0].removeEventListener("touchmove",() => {console.log("slider unlock touchmove removed")});
            $("#slider-unlock")[0].removeEventListener("touchend",() => {console.log("slider unlock touchend removed")});
        }
        localStorage.setItem("door_key_opened",true)        

        // if(window.FirebasePlugin){
        //     window.FirebasePlugin.setCrashlyticsCustomKey('door_key_opened', true);
        //   }
    }

    componentDidUpdate() {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        /*if (this.props.runNativeCalls) {
            this.props.SetCallNativeMethods(false);
            // this.setState({ message: gettingKeyMsg, firstTimeRefresh: true });
            this.nativeCalls(SessionToken);
            console.log("componentDidUpdate gettingKeyMsg");
        }*/
    }

    runAfterPermissionsCheck(value) {

        console.log("Run After Permission Check value",value);

        if(value===0){
            this.setState({showLocationErrScreen:true, showBlankOverlay: false});
            return;
        }else{
            this.setState({showLocationErrScreen:false, showBlankOverlay: false});
        }


        // this.props.setShowRoomDoor(false);

        const sessionToken = localStorage.getItem('GuestJourneySessionToken');
        let reservationNo = this.props.CheckedInGuest[0] ? this.props.CheckedInGuest[0].reservationNumber : null;
        let room = localStorage.getItem("room");

        // console.log("Room door mounted guest detail",this.props.CheckedInGuest);

        this.setState({doorKeyOpened:localStorage.getItem('door_key_opened')})
        this.setupSliderEventHandler();

        if (!reservationNo || reservationNo === "null") {
            if(process.env.REACT_APP_INROOMTAB == "true") {
                this.props.setLoginRequired(true)
            } else {
                this.props.setRegPage(true);
            }
        } else {
            // this.setState({ message: gettingKeyMsg });
            this.nativeCalls(sessionToken,reservationNo,room);
            console.log("componentDidMount gettingKeyMsg")
        }

        $("#room_door_back").attr("style","color:#fff !important;");
    }

    componentDidMount(){
        this.props.currentWidget({widgetType: true});
        this.setupSliderEventHandler();
        // this.requestLocationPermission();
        /*if(window.android){
            window.android.checkPermissions();
        }*/
    }

    tryAgainClick = () => {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let reservationNo = this.props.CheckedInGuest[0] ? this.props.CheckedInGuest[0].reservationNumber : null;
        let room = localStorage.getItem("room");

        if (this.state.tryAgainCase === "onKeySuccess") {
            this.nativeCalls(SessionToken, reservationNo, room);
        }else{
            this.setState({showOverlay:true,overlayComp:"attention"})
            this.nativeCalls(SessionToken, reservationNo, room);
        }
    }

  renewDoorKey = () => {        
          this.props.setShowCustomPopup(true, {
              htmlTagId: "renewDoorKey",
              heading: this.props.t('door_key.renew_door_key_process.heading'),
              subHeading: this.props.t('door_key.renew_door_key_process.subHeading'),
              primaryButtonText: this.props.t('door_key.renew_door_key_process.primaryButtonText'),
              secondaryButtonText: this.props.t('door_key.renew_door_key_process.secondaryButtonText'),
              primaryOnClick: ()=>{ this.processDoorKeyRenewal()},
              secondaryOnClick:()=>{this.props.setShowCustomPopup(false,{})},
              closeOnClick:()=>{this.props.setShowCustomPopup(false,{})},
          })
    }

    processDoorKeyRenewal = async()=>{
        this.props.setShowCustomPopup(false,{})
        await clearDoorKey();
    }

    render(){
        const { t } = this.props
        return(
            // this.props.showDoorKeyPopup ? <DoorKeyPopup /> :
            <div className="main-container background-overlay" style = {{minHeight:"100vh"}}>
                <header className="inner-pages subpages no-background" 
                style = {{
                    backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                    color: this.props.menuColor.assetFontColor
                }}>
                    <Link style={{color:"#fff"}} exact to="/" className="button-back" id="room_door_back"></Link>
                    
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit",textShadow:"unset"}}>{this.props.t('door_key.header')}</p> */}
                    </div>
                </header>
                <section id="doorLocks" className="widgets padding-bottom-2 margin-0">

                    <div class="widget-header">
		                <div class="widget-header-title">{this.props.t('door_key.header')}</div>
		            </div>

                    <div className="widgets">
                        <div className="row">
                            <div className="col">
                                <div className={`unlock-container door-${this.state.doorUnlocked ? "unlocked" : "locked"}`}>

                                    <div class="unlock-container">
                                        <p>{this.props.t('door_key.your_room_number')}</p>
                                        <h1 class="align-center">{this.state.room}</h1>
                                        <div class="unlock-button-container">
                                            <div class="unlock-button-l0">
                                                <div onClick={this.handleActivateDoorKeyFileHanlder} class="unlock-button-l1">
                                                    <div class="unlock-button-l2">
                                                        <div class="unlock-button-l3">
                                                            <a class="unlock-button-main">{this.state.doorUnlocked ? this.props.t('door_key.activated') : this.props.t('door_key.header_text3')}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="heading bottom">
                                            <img src={"doorKeyGuide_images/img_door_unlock.png"} />
                                            {this.props.t('door_key.unlock_text')}
                                        </p>
                                    </div>
                                    <div class="renew-door-key-button" onClick={this.renewDoorKey}>
                                        <div class="text">
                                            <div class="label">
                                                <div class="label2">{this.props.t('door_key.renew_door_key_button_text')}</div>
                                            </div>
                                            <div class="border"></div>
                                        </div>
                                    </div>

                                    {/* older HTML */}
                                    {/* {(this.state.doorKeyOpened == "null") ? <h1 className="align-center">{this.state.room}</h1> : <br/>}
                                    <p className="heading" style = {{marginBottom:"2rem", marginTop:"3rem"}}>{this.state.doorUnlocked ? this.props.t('door_key.header_text1') :  this.props.t('door_key.header_text2')}</p>
                                    <div id="unlockDiv" className="unlock">
                                        <h2>
                                            <strong id="slider-unlock" className={`slider-button ${this.state.doorUnlocked ? "active" : ""}`} 
                                            style = {{
                                                backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                                                // left: this.state.sliderLeft + "px",
                                                transform:`translateX(${this.state.sliderLeft}px)`
                                            }}></strong>
                                            <div className="door-icons">
                                                {!this.state.doorUnlocked && <span className="icon-lock"></span>}
                                                <span className="icon-unlock"></span>
                                            </div>
                                            <span className={`unlock-text`}>{this.state.doorUnlocked ? "Activated" : "Activate"}</span>
                                        </h2>
                                    </div>
                                    <p class="heading bottom" style = {{marginTop:"2rem"}}>
                                        {this.props.t('door_key.unlock_text')}
                                        <img src={doorUnlockSVG} />
                                    </p> */}
                                    {/* <p className="heading" style = {{marginTop:"2rem"}}>Unlock the door by "tapping" the phone on the door lock</p> */}
                                    {/*<div className="subheading">
                                        <span className="icon-lock"></span>
                                        <span className="icon-unlock"></span>
                                        <p>{this.state.doorUnlocked ? "Door unlocked" : "Door locked"}</p>
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="doorkey">
                        
                        <Link exact to="/" className="tile-container" 
                        style = {{
                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor,
                            color: this.props.menuColor.assetFontSelectorColor
                        }}>
                            <i className="fas fa-times" ></i>
                        </Link>
                    </div>
                </section>
                {this.state.showBlankOverlay && <MobileKeyOverlay overlay="blank"/>}
                
                {!this.state.showLocationErrScreen && this.state.showOverlay && <MobileKeyOverlay overlay = {this.state.overlayComp} message = {this.state.overlayMsg}
                tryAgain = {this.tryAgainClick} close = {() => {this.setState({showOverlay:false})}} errorClose = {() => this.props.setGoHome(true)}/>}
                
                {this.state.showLocationErrScreen && <MobileKeyOverlay overlay="error" locationErr={true} 
                            message={t('door_key.location_access_required')}
                            titleMsg={t('door_key.location_access_err')}
                            errorClose={() => this.props.setGoHome(true)}
                            hideTryAgain={true}/>}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        menuColor: state.store.home.MenuColor,
        showDoorKeyPopup:state.store2.showDoorKeyPopup,
        guestDetail: state.store.home.guestDetails,
        reservationNo: state.store.reservationNo,
        runNativeCalls: state.store.doorKey.runNativeCalls,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        CheckedInGuest: state.store.CheckedInGuest,
        
    }
}

export default connect(mapStateToProps,{
    currentWidget,
    setShowDoorKeyPopup,
    setDoorKeyNotificaionPage,
    popupOpenClose,
    setLoginRequired,
    setDeviceLoginPage,
    setDoorKeyValidationPopUp,
    SetCallNativeMethods,
    setRegPage,
    setShowRoomDoor,
    setGoHome,
    setShowCustomPopup,
    setCallKeyclick
})(withTranslation('translations')(RoomDoor));